import PremissasViagemView from "../../components/gestaoOrcamentaria/PremissasViagemView";

export default function PremissasViagem() {
  return <PremissasViagemView />;
}
